// ./components/Navbar.js
import '../index.css';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Container from 'react-bootstrap/esm/Container';
import NavItem from 'react-bootstrap/esm/NavItem';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';




const NavMain = () => {
    return (
      <Navbar id="painNav"  collapseOnSelect className='toPlace shadow' fixed='top' expand="lg" bg="dark" data-bs-theme="dark" > 
          <Navbar.Toggle id='thatToggle' aria-controls="basic-navbar-nav" style={{justifyContent:"center"}}>
            <img
                  alt=""
                  src='img/Logo Red.svg'
                  width="35"            
                  height= "35"
                  className="d-inline-block align-items-baseline"
                  
                />
          </Navbar.Toggle>
        
        <Navbar.Brand  href="#home" className='branded' >
                <h3 className="d-inline-block">
                  <b>
                    AP<img
                  alt=""
                  src='img/Logo Red.svg'
                  width="35"            
                  height= "35"
                  className="d-inline-block align-items-baseline"
                  
                />X Performance
                  </b>
                </h3> 
                
              </Navbar.Brand>
              
        <Navbar.Collapse id="basic-navbar-nav">
          <Container className='navi' fluid >
          <Nav justify fill="true"className='gohead' id='menu'>
            <NavItem>
              <Nav.Link id="basic-navbar-nav" href="#home">Home</Nav.Link>
            </NavItem>
            <Nav.Item>
              <Nav.Link href='#plans'>Plans</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link href='#results'>Results</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link href='#about'>About</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Row>
                <Col>
                  <Nav.Link href='https://www.instagram.com/apexperformancefit?igsh=MWt1NXBucWszNWZyaQ=='><img
                    alt='Instagram'
                    src='img/instagram icon.png'
                    width={48}
                    height={48}
                    />
                  </Nav.Link>
                  
                </Col>
                <Col>
                  <Nav.Link><img
                    alt='Facebook'
                    src='img/facebook Icon.png'
                    width={48}
                    height={48}
                    />
                  </Nav.Link>  
                </Col>
              </Row>
              </Nav.Item>
          </Nav>
          </Container>
        </Navbar.Collapse>
      
    </Navbar>
    


    );
}

export default NavMain;